export const IOSIcon = ({ fill }) => {
  return (
    <svg
      width="20"
      height="24"
      viewBox="0 0 20 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.3237 12.7508C16.2936 9.7126 18.8017 8.25461 18.9137 8.18243C17.504 6.12032 15.3077 5.83688 14.5251 5.80501C12.6561 5.61632 10.8787 6.90601 9.9292 6.90601C8.98227 6.90601 7.51896 5.83332 5.9693 5.8617C3.93243 5.89181 2.05455 7.0464 1.0045 8.8707C-1.11168 12.5422 0.463222 17.984 2.52582 20.9612C3.53338 22.4192 4.73495 24.057 6.31296 23.9985C7.83207 23.9387 8.40694 23.0144 10.2445 23.0144C12.0816 23.0144 12.5976 23.9985 14.2058 23.9671C15.8409 23.9369 16.8768 22.4807 17.8777 21.0179C19.0359 19.326 19.5107 17.69 19.5395 17.6058C19.5031 17.5894 16.3511 16.3821 16.3192 12.7522L16.3237 12.7508ZM13.3032 3.83233C14.1402 2.81678 14.7058 1.40706 14.5512 0C13.3452 0.0491594 11.8828 0.803836 11.017 1.81807C10.2397 2.71846 9.56071 4.15342 9.74231 5.53169C11.0891 5.63668 12.4643 4.84743 13.3018 3.83409L13.3032 3.83233Z"
        fill={fill}
      />
    </svg>
  );
};
